import { Component, Vue } from "vue-property-decorator";

@Component
export default class ConfirmModal extends Vue {
  close(): void {
    this.$emit("close");
  }

  confirm(): void {
    this.$emit("ok");
  }
}
